import { render } from "./customers-subpage.vue?vue&type=template&id=631e9340"
import script from "./customers-subpage.vue?vue&type=script&lang=js"
export * from "./customers-subpage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__